import { hydrate } from 'preact';
import './assets/scss/styles.scss';
import { Drawer, Collapse } from 'flowbite';


//import { register } from 'swiper/element/bundle';
// register Swiper custom elements


//import FrameListPage from './pages/frame-list.tsx';
import App from './app.tsx';

//const FramesPage = lazy(() => import('./pages/frames.tsx'));



hydrate(<App />, document.getElementById('app')!);

const holidayBanner = document.getElementById('holiday-banner');
if (holidayBanner) {
    const banner = new Drawer(holidayBanner, {
        backdrop: true,
        //backdropClasses: 'bg-black',
        placement: 'top',
        onHide: () => {
            sessionStorage.setItem('holiday-banner', (new Date()).toJSON());
        }

    });
    const holidayBannerShown = sessionStorage.getItem('holiday-banner');
    if (!holidayBannerShown) {
        banner.show();
    }
    
}

const navbarDefault = document.getElementById('navbar-default');
if (navbarDefault) {
    const navbar = new Collapse(
        navbarDefault, 
        document.querySelector<HTMLButtonElement>('#navbar-button'), 
        {}, { id: 'navbar-default', override: true}
    );
    navbarDefault.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).closest('[data-collapse-toggle]')?.dataset.collapseToggle !== undefined) {
            return;
        }
        navbar.collapse();
    });
}